var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"no-results-found"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(!_vm.text ? '해당내용이 없습니다.' : _vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }